function acs_showLoading() {
    const loading = document.querySelector(".acs_loading");
    if (loading) loading.style.display = "block";
}

function acs_hideLoading() {
    const loading = document.querySelector(".acs_loading");
    if (loading) loading.style.display = "none";
}

function acs_fetchPlp() {
    graphenehc.load({
        template        : { id: "category", target: ".acs_results" },
        include         : ["breadcrumb", "page"],
        init            : function() {
            acs_showLoading();
        },
        success         : function (response) {
            acs_hideLoading();
        }
    });
}

function acs_fetchSearch() {
    graphenehc.load({
        template        : { id: "search", target: ".acs_results" },
        include         : ["page"],
        init            : function() {
            acs_showLoading();
        },
        success         : function (response) {
            acs_hideLoading();
        }
    });
}